<template>
    <svg width="12" height="12" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#1kkpgfqaga)">
            <path
                d="M11.5 5.5H8.95A2.997 2.997 0 0 0 6.5 3.05V.5C6.5.22 6.28 0 6 0s-.5.22-.5.5v2.55c-1.25.21-2.24 1.2-2.45 2.45H.5c-.28 0-.5.22-.5.5s.22.5.5.5h2.55c.21 1.25 1.2 2.24 2.45 2.45v2.55c0 .28.22.5.5.5s.5-.22.5-.5V8.95c1.25-.21 2.24-1.2 2.45-2.45h2.55c.28 0 .5-.22.5-.5s-.22-.5-.5-.5zM6 7.5c-.83 0-1.5-.67-1.5-1.5S5.17 4.5 6 4.5s1.5.67 1.5 1.5S6.83 7.5 6 7.5z"
            />
        </g>
        <defs>
            <clipPath id="1kkpgfqaga">
                <path fill="#fff" d="M0 0h12v12H0z" />
            </clipPath>
        </defs>
    </svg>
</template>
